/**
 * Loading Spinner Component
 */
import React from 'react'

interface LoadingSpinnerProps {
  className?: string
}

export default function LoadingSpinner ({ className }: LoadingSpinnerProps): React.JSX.Element {
  const totalDots = 8

  return (
    <div className={`flex justify-center items-center py-2 ${className}`} data-testid="loading-spinner">
      <div className="relative w-8 h-8">
        {Array.from({ length: totalDots }, (_, i) => {
          const angle = (i * 360) / totalDots
          const radius = 20
          const x = radius * Math.cos((angle * Math.PI) / 180)
          const y = radius * Math.sin((angle * Math.PI) / 180)

          return (
            <div
              key={i}
              className="absolute w-2 h-2 rounded-full transition-colors duration-150"
              style={{
                left: `calc(50% + ${x}px)`,
                top: `calc(50% + ${y}px)`,
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgb(217, 217, 217)',
                animationDelay: `${i * 0.125}s`,
                animationDuration: '1s',
                animationIterationCount: 'infinite',
                animationName: 'dot-highlight',
              }}
            />
          )
        })}
      </div>

      <style>{`
        @keyframes dot-highlight {
          0%, 87.5% { background-color: rgb(209, 213, 219); }
          12.5% { background-color: rgb(31, 41, 55); }
        }
      `}
      </style>
    </div>
  )
}
